import { Domain, createDomain, combine, Event } from 'effector';
import { createRequestEffect, RequestEffectSetting } from './request-effect';
import { createRequestStatus } from './request-status';
import isEqual from 'lodash.isequal';
import isEmpty from 'lodash/isEmpty';

function createRequestStore<Data, Params, Done>(
  opt: RequestEffectSetting<Data, Params>,
  initial: Done,
  params?: { domain?: Domain; reset?: Event<any> }
) {
  const { domain = createDomain() } = params || {};
  const reset = params?.reset || domain.createEvent();

  const $store = domain.createStore<Done>(initial);
  const fx = createRequestEffect<Data, Params, Done>(opt, domain);

  $store
    .on(fx.doneData, (store, data) => (isEqual(store, data) ? store : data))
    .reset(reset);

  const $loading = createRequestStatus(
    { effect: fx, initialValue: !isEmpty(initial) ? 'done' : 'loading' },
    { reset, domain }
  );

  const $combined = combine({ data: $store, loading: $loading });

  return {
    $store,
    $loading,
    $combined,
    fx,
    reset
  };
}

export { createRequestStore };
